import type { BadgeProps } from '@/components/ui/badge';
import type { AnomalySeverity } from '@services/activity.service';

/**
 * `low` was MUI Chip's `default`, which is not a palette entry at all — it is
 * the component's grey fallback, so it maps to the secondary badge.
 */
export const SEVERITY_VARIANT: Record<AnomalySeverity, BadgeProps['variant']> = {
  low: 'secondary',
  medium: 'info',
  high: 'warning',
  critical: 'destructive',
};

/**
 * Radix throws on `value=""`, which is what the severity and status filters
 * both use for "all". Mapped back before the value reaches activityService.
 */
export const ALL_ANOMALY_FILTER = '__anomaly_filter_all__';

export const toSelectValue = (filter: string): string =>
  filter === '' ? ALL_ANOMALY_FILTER : filter;

export const fromSelectValue = (value: string): string =>
  value === ALL_ANOMALY_FILTER ? '' : value;
